import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const POSTS_API = "https://fetc.in/api/v1/posts";

export const postApi = createApi({
  reducerPath: "postsApi",
  tagTypes: ["Posts"],
  baseQuery: fetchBaseQuery({ baseUrl: POSTS_API, credentials: "include" }),
  endpoints: (builder) => ({
    createPost: builder.mutation({
      query: (formData) => ({
        url: "/create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Posts"],
    }),

    getPosts: builder.query({
      query: () => "/list",
      providesTags: ["Posts"],
    }),

    getPublishedPosts: builder.query({
      query: () => "/published",
      providesTags: ["Posts"],
    }),

    getCreatorPosts: builder.query({
      query: () => "/user",
      providesTags: ["Posts"],
    }),

    getPostBySlug: builder.query({
      query: (slug) => `/${slug}`,
      providesTags: (result, error, slug) => [{ type: "Posts", id: slug }],
    }),

    editPost: builder.mutation({
      query: ({ slug, formData }) => ({
        url: `/${slug}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, { slug }) => [
        { type: "Posts", id: slug },
        "Posts",
        ...(result?.post?.slug && result.post.slug !== slug
          ? [{ type: "Posts", id: result.post.slug }]
          : []),
      ],
    }),

    deletePost: builder.mutation({
      query: (slug) => ({
        url: `/${slug}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Posts"],
    }),
  }),
});

export const {
  useCreatePostMutation,
  useGetPostsQuery,
  useGetPublishedPostsQuery,
  useGetCreatorPostsQuery,
  useGetPostBySlugQuery,
  useEditPostMutation,
  useDeletePostMutation,
} = postApi;
